import MessageThreadList from './MessageThreadList';

export default MessageThreadList;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageThreadList/index.js